// TODO: This really needs to go away.  It has terrible performance and is a poor design.
// TODO: FLAGGED SELECTOR
// Remove useless links
$("a[href*='history.go(']").remove();
